<template>
  <div class="mainPage">
    <div class="title">{{title}}</div>
    <div class="buttons">
      <div class="button" @click="start">开始比赛</div>
      <div class="button" @click="toRank">积分排行</div>
      <div class="button" @click="rule">赛制规则</div>
    </div>
    <div class="foot">
      <div class="content">苏州市教育局、苏州市科协、AI世青赛组委会</div>
      <div class="content">“数字公民”课程基地校与联盟校</div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
   computed: {
     title () {
       return '“数字公民”科技月青少年编程竞技场暨AI世青赛苏州地区选拔赛'
     },
   },
   methods: {
     toRank () {
       this.$emit("toRank")
     },
     start() {
       window.open("https://koudashijie.com/students?_cc=SoupNorthCold", "_blank")
     },
     rule() {
       /* window.open("https://suzhou.koudashijie.com/rule", target="_blank") */
       window.open(window.location.href + "/rule", "_blank")
     }
   },
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .mainPage {
   display: flex;
   flex-direction: column;
   align-items: center;
  }
 .title{
   font-size: 4vw;
   font-family: 'kaiti';
   font-weight: 600;
   width: 18em;
   text-align: center;
   color: white;
   margin-top: 8vw;
 }
 .foot{
   font-size: 2vw;
   font-family: 'simfang';
   text-align: center;
   margin-top: 8vw;
   color: white;
 }
 .buttons{
   display: flex;
   width: 60vw;
   align-items: center;
   justify-content: space-around;
 }
 .buttons .button{
   font-size: 32px;
   width: 6.8em;
   height: 2.4em;
   border-radius: 0.5em;
   background-color: #FFC000;
   display: flex;
   align-items:center;
   justify-content:center;
   margin-top: 10vw;
 }
</style>
